import { ethers } from "ethers";
import { ACTIVE_CONTRACTS } from "../config/app.config";

import PurchaseAbi from "../abis/SmartcoreNodePurchase.json";
import ScnAbi from "../abis/SCNToken.json";
import ScnDexAbi from "../abis/SCNDex.json";
import CoreDexAbi from "../abis/CoreDex.json";
import CoreTokenAbi from "../abis/CoreToken.json";
import CoreMiningAbi from "../abis/CoreMining.json";
import Erc20Abi from "../abis/ERC20.json";

const C = ACTIVE_CONTRACTS;

export const getPurchase = (sp) => new ethers.Contract(C.smartcorePurchase, PurchaseAbi, sp);
export const getScnToken = (sp) => new ethers.Contract(C.scnToken, ScnAbi, sp);
export const getScnDex = (sp) => new ethers.Contract(C.scnDex, ScnDexAbi, sp);
export const getCoreDex = (sp) => new ethers.Contract(C.coreDex, CoreDexAbi, sp);
export const getCoreToken = (sp) => new ethers.Contract(C.coreToken, CoreTokenAbi, sp);
export const getCoreMining = (sp) => new ethers.Contract(C.coreMining, CoreMiningAbi, sp);
export const getUsdt = (sp) => new ethers.Contract(C.usdt, Erc20Abi, sp);
